import { AppearanceTheme } from "./theme";
import navigationBg from "./assets/bg/bg_header_seeds.png";
import sideBg from "./assets/bg/bg_side_seeds.png";

/** 用户信息 localstorage key */
export const LOCALSTORAGE_USERINFO = "userinfo";
/** 用户名 localstorage key */
export const LOCALSTORAGE_USERNAME = "username";
/** 收藏列表 key */
export const WE_COLLECT_TAG = "WE_COLLECT";
/**  banner容器id */
export const WE_BANNER_ID = "WE-Header-Banner";
/** seeds-pro 默认样式 */
export const DEFAULT_APPEARANCE_THEME: AppearanceTheme = {
  type: "dark",
  "navigation.backgroundColor": "#181c24",
  "navigation.backgroundImage": `url(${navigationBg})`,
  "navigation.appName.color": "#fff",
  "navigation.appDropdown.shadow": "rgb(0 0 0 / 0.04)",
  "navigation.appDropdown.arrowIcon.color": "rgb(255 255 255 / 0.4)",
  "navigation.appDropdown.arrowIcon.hoverColor": "#fff",
  "navigation.appDropdown.arrowIcon.backgroundColorEnd": "#191c26",
  "navigation.appDropdown.card.boxShadow": "red",
  "navigation.operation.color": "#fff",
  "aside.backgroundColor": "#181c24",
  "aside.backgroundImage": `url(${sideBg})`,
  "aside.menu.outline": "rgb(232 232 232 / 0.2)",
  "aside.menu.title.color": "rgb(255 255 255 / 0.6)",
  "aside.menu.title.hoverColorStart": "#fff",
  "aside.menu.title.hoverColorEnd": "#fff",
  "aside.menu.subTitle.color": "rgb(255 255 255 / 0.6)",
  "aside.menu.subTitle.selectedColorStart": "#728bff",
  "aside.menu.subTitle.selectedColorEnd": "#ec6e7f",
  "aside.menu.hoverBackgroundColor": "rgb(255 255 255 / 0.06)",
  "aside.expandIcon.color": "#fff",
  "aside.expandIcon.backgroundColor": "rgb(255 255 255 / 0.1)",
  "aside.menu.title.selectedColor": "#fff",
  "aside.menu.selectedBackgroundColorStart": "rgb(255 255 255 / 0.06)",
  "aside.menu.selectedBackgroundColorEnd": "rgb(255 255 255 / 0.06)",
  "aside.collect.title.color": "#a7b4d0",
  "aside.collectItem.title.color": "#a7b4d0",
};
/** 应用枚举值 */
export enum App {
  PLATFORM = "Platform",
  WE_OPP = "WE-OPP",
  WE_SEEDS = "We-Seeds",
  WE_SEEDS_PRO = "We-Seeds-Pro",
  POWER = "Power",
  SUPPORT = "Support",
  WE_POWER_NEW = "We-Power-New",
  WE_STAR = "We-Star",
  WE_SECURITY = "We-Security",
}

/**
 * 组件类型(0：菜单，1：链接，2：按钮，3：目录, 4：分组)
 */
export enum AppMenuType {
  MENU = 0,
  LINK = 1,
  BUTTON = 2,
  FOLDER = 3,
  GROUP = 4,
}
